import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_Temp_Quotation_Item_Detail"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

let fields = {
  default: [
    { key: "id", label: "编号" },
    { key: "ParentId", label: "父id" },
    { key: "QuotationId", label: "临时报价id" },
    { key: "PartName", label: "临时报价id" },
    { key: 'ItemTypeId', label: '物料类型' },
    { key: 'ItemTypeName', label: '物料类型' },
    { key: 'ItemId', label: '物料id' },
    { key: 'ItemName', label: '物料名称' },
    { key: 'Spec', label: '规格' },
    { key: 'TEC_GoLength', label: '上机长mm' },
    { key: 'TEC_GoWidth', label: '上机宽mm' },
    { key: 'Mould_Count', label: '排版模数' },
    { key: 'UseLength', label: '用料长mm' },
    { key: 'UseWidth', label: '用料宽mm' },
    { key: 'Cut_Count', label: '开数' },
    { key: 'MatchA', label: '配比数A' },
    { key: 'MatchB', label: '配比数B' },
    { key: 'Unit_Count', label: '单位用量' },
    { key: 'Unit_Use', label: '计量单位' },
    { key: 'Total_Qty', label: '总用量' },
    { key: 'Description', label: '备注' }
  ]
}

const dataForm = {}

const validatePositive = (rule, value, callback) => {
  if (!value && value != 0) { // 空值（未填写）
    callback(new Error('请输入数值'))
  }
  if (typeof value !== 'number') {
    callback(new Error('请输入有效数字！'))
  }
  if (value <= 0) { // 小于0
    callback(new Error('必须大于0！'))
  }
  else
    callback()
}
///前端验证
const rules = {
  PartName: [
    { required: true, message: '请填写部件名称', trigger: 'blur' }
  ],
  // Unit_Count: [
  //   { required: true, validator: validatePositive, trigger: 'blur' },
  // ],
  Unit_Use: [
    { required: true, message: '请选择计量单位', trigger: 'change' }
  ],
  MatchA: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
  MatchB: [
    { required: true, validator: validatePositive, trigger: 'blur' }
  ],
}

const methods = {
  async getTempQuotaionPriceList(params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_temp_quotation_price_list",
      {},
      {}
    )
    let _fields = _.map(fields.default, "key")
    _fields.push("Calc_Total_Qty")
    _fields.push("Unit_Cost")
    _fields.push("Calc_Item_Price")
    _fields.push("Total_Cost")
    _fields.push("Item_Price")

    let result = await item_biz_data
      .execAction({
        params: params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(params) {
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        delete params[k].id
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.removeAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

